import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useFlakeApprovals from '@/composables/farm/useFlakeApprovals';
import { TransactionActionInfo } from '@/types/transactions';

export default function useFlakeApprovalActions(
  tokenAddresses: string[],
  amounts: Ref<string[]>
) {
  const { t } = useI18n();
  const {
    requiredApprovalState,
    approveToken,
    dynamicDataLoading
  } = useFlakeApprovals(tokenAddresses, amounts);

  const tokenApprovalActions: TransactionActionInfo[] = Object.keys(
    requiredApprovalState.value
  ).map(address => {
    return {
      label: 'Approve FLAKE for staking',
      loadingLabel: t('investment.preview.loadingLabel.approval'),
      confirmingLabel: t('confirming'),
      stepTooltip:
        'You must approve FLAKE to stake this token on Hexagon. Approvals are required once per token, per wallet.',
      action: () => {
        return approveToken(address);
      }
    };
  });

  return {
    tokenApprovalActions,
    dynamicDataLoading
  };
}
